export const ID_CIT = "CIT";
export const ID_MIT = "MIT";
export const ID_PRE_AUTHORIZED = "PRE_AUTHORIZED";